{
  "email": {
    "trains": {
      "notifications": {
        "services": "Please note that the allowance for your flight and train connection might differ. You can review the details below.",
        "benefits": "This route includes a train connection operated by our partner. Please note, benefits in your ticket type only apply to the flights in your booking."
      },
      "sustainabilityNote": "By choosing a train connection you are reducing your carbon footprint of travel. Thank you!",
      "operatorInfo": {
        "W2": {
          "title": "Your train connection with Deutsche Bahn",
          "checkInNote": "Please <b>check in for your train connection</b> separately on Deutsche Bahn site using your <b>Finnair booking reference</b>.",
          "checkInUrl": "https://rail-checkin.com/#/login",
          "buttonText": "Check in with Deutsche Bahn"
        }
      }
    }
  },
  "services": {
    "productCards": {
      "confirm": "Confirm"
    }
  }
}
